import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import {
    chipAggregatedLabel,
    chipItemLabel,
    renderCollectionChips,
    useChipFiltersStore,
} from "../BaseChipComponents/chipUtils";

export const ConversationLabelingChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const { dataLabels, containsDataLabels } = applicationFiltersStore;

    if (containsDataLabels === undefined || dataLabels.length === 0) return null;

    const setLabelsAndNormalizeMode = (nextLabels: typeof dataLabels) => {
        applicationFiltersStore.setConversationLabels(nextLabels);
        if (nextLabels.length === 0)
            applicationFiltersStore.setContainsConversationLabels(undefined);
    };

    const handleRemoveAll = () => {
        setLabelsAndNormalizeMode([]);
    };

    return renderCollectionChips({
        items: dataLabels,
        disabled: props.disabled,
        isApplicable: props.isApplicable,
        getKey: (label) => label.id,
        getLabel: (label) =>
            chipItemLabel(
                "Conversation Labeling",
                label.name,
                !containsDataLabels,
            ),
        getTooltipLabel: (label) => label.name,
        getAggregatedLabel: (count) =>
            chipAggregatedLabel(
                count,
                "Conversation Labeling",
                !containsDataLabels,
            ),
        onRemoveAll: handleRemoveAll,
        onRemoveItem: (label) =>
            setLabelsAndNormalizeMode(
                dataLabels.filter((l) => l.id !== label.id),
            ),
    });
});
